import APIService from '../../../Services/APIService';
import { Apis } from '../../../Services/app.constants';

function unwrapAxios(res) {
  const ok = res?.status >= 200 && res?.status < 300;
  const body = res?.data;
  let payload = body;

  if (body && typeof body === 'object' && 'data' in body) {
    payload = body.data;
  }

  return { ok, data: payload, status: res?.status ?? 0, raw: res };
}

export const rbacService = {
  async getPermissionCatalog() {
    const res = await APIService.get(Apis.rbacPermissions);
    return unwrapAxios(res);
  },

  async getProfileById(profileId) {
    const res = await APIService.get(`${Apis.rbacProfiles}${profileId}/`);
    return unwrapAxios(res);
  },

  async getClonePreview(profileId) {
    const res = await APIService.get(`${Apis.rbacProfiles}${profileId}/clone-preview/`);
    return unwrapAxios(res);
  },

  async getDeleteGuard(profileId) {
    const res = await APIService.get(`${Apis.rbacProfiles}${profileId}/delete-guard/`);
    return unwrapAxios(res);
  },

  async getProfiles({ search = '', page = 0, limit = 20, organisationId = '' } = {}) {
    const params = new URLSearchParams({
      next_page: String(Number(page) + 1),
      limit: String(limit),
    });
    if (search) {
      params.set('search', search);
    }
    if (organisationId) {
      params.set('organisation_id', organisationId);
    }
    const res = await APIService.get(`${Apis.rbacProfiles}?${params}`);
    return unwrapAxios(res);
  },

  async createProfile(payload) {
    const res = await APIService.post(Apis.rbacProfiles, payload);
    return unwrapAxios(res);
  },

  async updateProfile(profileId, payload) {
    const res = await APIService.put(`${Apis.rbacProfiles}${profileId}/`, payload);
    return unwrapAxios(res);
  },

  async deleteProfile(profileId) {
    try {
      const res = await APIService.remove(`${Apis.rbacProfiles}${profileId}/`);
      return unwrapAxios(res);
    } catch (err) {
      const res = err?.response;
      if (res) {
        return unwrapAxios(res);
      }
      throw err;
    }
  },

  async updateProfileGrants(profileId, permissions) {
    const res = await APIService.put(`${Apis.rbacProfiles}${profileId}/grants/`, {
      permissions,
    });
    return unwrapAxios(res);
  },

  async cloneProfile(payload) {
    const res = await APIService.post(Apis.rbacProfilesClone, payload);
    return unwrapAxios(res);
  },

  async getResourceTree({ organisationId } = {}) {
    const query = organisationId
      ? `?organisation_id=${encodeURIComponent(organisationId)}`
      : '';
    const res = await APIService.get(`${Apis.rbacResourceTree}${query}`);
    return unwrapAxios(res);
  },
};

export default rbacService;
